/**
* @Author: Dmytro Mykhailov <dmitriymikhaylov>
* @Date:   2016-10-13T13:04:02+03:00
* @Email:  belindream@gmail.com
* @Project: Lumand
* @Last modified by:   dmitriymikhaylov
* @Last modified time: 2016-10-14T13:28:05+03:00
* @License: MIT
*/



import React from 'react'
import { connect } from 'react-redux'
import Omnibox from 'components/Omnibox'



export default (o) => {
return(
    <div className="header-wrapper">
      <header style={{height: "60px", top: "0", position: "fixed", zIndex: '800'}}>
        <div id="header-left" style={{position: "fixed", left: "15px", top: "12px"}}>
          <img src={"/manager/static/img/res/menu_burger.png"} style={{width: "28", height:"36", cursor: 'pointer'}}
            onTouchTap={o.handleToggleLeft}/>
          <img src={"/manager/static/img/siteLogo.png"} style={{height: "26", position:"relative", bottom:"6px", left: "10px"}}/>
          <span style={{fontSize:"24px", margin: "5px", position: "relative", bottom: "9px", left: "18px", fontFamily: "Verdana"}}>Tenants: {o.count}</span>
  		<Omnibox  style={{
			position: 'absolute'
		  , left: '410px'
		  , top: '-12px'
		}}/>
        </div>
      </header>
    </div>
)
}



// WEBPACK FOOTER //
// ./src/routes/manager/owners/ActionBar.js